export const itemMobileCenteringAnimationOptions = {
  animate: true,
  duration: 300,
};
